<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Gestão do Grupo SCFV") }}
        {{ $t("ID") }} #{{ item.id }}
      </h1>
    </div>
    <load v-if="loading" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <Header :item="item" />
        </div>
      </div>
      <div class="row">
        <Sidebar @page="showPage" :auditoria="item.auditoria" />
        <div class="col-md-9">
          <div v-if="page == 'scfv'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="row">
                      <form-input
                        v-model="item.nome_grupo"
                        grid="6"
                        label="Nome do Grupo"
                        :required="true"
                      />
                      <form-select
                        v-model="item.faixa_etaria"
                        grid="6"
                        label="Faixa Etária"
                        :itens="$root.arrays.scfv_faixa_etaria"
                        :required="true"
                      />
                      <form-select
                        v-model="item.acesso"
                        grid="3"
                        label="Acesso"
                        :itens="$root.arrays.scfv_acesso"
                      />
                      <form-select
                        v-model="item.periodicidade"
                        grid="3"
                        label="Periodicidade"
                        :itens="$root.arrays.scfv_periodicidade"
                        :required="true"
                      />

                      <form-select
                        v-model="item.dias_semana"
                        grid="6"
                        label="Dia(s) da Semana"
                        :itens="$root.arrays.scfv_dias_semana"
                        :required="true"
                        :multiple="true"
                      />

                      <form-calendar
                        v-model="format_hora"
                        grid="4"
                        label="Horário"
                        mode="time"
                      />
                      <form-input
                        v-model="item.numero_vagas"
                        type="number"
                        grid="4"
                        label="Vagas"
                        :min="3"
                      />

                      <form-input
                        v-model="item.carga_horaria"
                        type="number"
                        grid="4"
                        label="Carga Horária"
                        :required="true"
                        :min="1"
                      />

                      <form-select
                        v-model="item.carater"
                        grid="6"
                        label="Caráter"
                        :itens="$root.arrays.scfv_carater"
                      />

                      <form-select
                        v-model="item.forma_execucao"
                        grid="6"
                        label="Forma de Execução"
                        :itens="$root.arrays.scfv_execucao"
                        @change="formaExecucao"
                      />

                      <form-select
                        v-model="item.unidade_osc_id"
                        grid="12"
                        label="Selecione uma OSC"
                        :itens="unidades"
                        v-if="campoExtra == true"
                      />

                      <form-select
                        v-model="item.unidade_base_id"
                        grid="6"
                        label="Base Física das Atividades"
                        :itens="unidades"
                        :required="true"
                      />

                      <form-select
                        v-model="item.tecnico_id"
                        grid="6"
                        label="Técnico de Referência"
                        :itens="tecnicos"
                        :required="true"
                      />

                      <form-select
                        v-model="item.orientador_id"
                        grid="6"
                        label="Orientador Social"
                        :itens="tecnicos"
                        :required="true"
                      />

                      <form-select
                        v-model="item.facilitador_id"
                        grid="6"
                        label="Facilitador de Oficinas"
                        :itens="tecnicos"
                      />
                      <label class="d-block font-weight-bold pl-3 mt-2"
                        >Selecione o(s) técnico(s) participante(s)</label
                      >
                    </div>
                    <search-tecnico-grupo
                      :grupo-id="item.id || null"
                      :tecnicos.sync="item.tecnicos"
                      col="6"
                    />
                    <div class="row">
                      <form-textarea-editor
                        v-model="item.observacoes"
                        label="Objetivos"
                        :required="true"
                      />

                      <form-select
                        @change="verificarStatus"
                        v-model="item.status"
                        label="Status"
                        grid="4"
                        :itens="status"
                      />

                      <form-file
                        grid="8"
                        @submit="submitFile"
                        multiple
                        btn-text="Iniciar"
                        :progress="progressCompleted"
                      />
                    </div>
                    <div class="row pt-4 px-0 d-flex justify-content-end">
                      <div class="col-auto px-2 text-right">
                        <a
                          class="router-link-exact-active active px-3"
                          @click="historicoStatus = true"
                        >
                          <i class="fas fa-history"></i> Histórico de Status
                        </a>
                        <router-link
                          to="/dashboard/scfv/"
                          class="btn btn-default"
                        >
                          <i class="mdi mdi-arrow-left" />
                        </router-link>
                        <b-button
                          :title="$t('Visualizar e Imprimir')"
                          :to="'/dashboard/scfv/show/' + item.id"
                          class="py-1"
                          size="sm"
                          type="button"
                          v-b-tooltip.hover
                          variant="primary"
                        >
                          <i class="mdi mdi-printer mdi-18px" />
                        </b-button>
                        <button
                          class="btn btn-success btn-submit"
                          data-style="zoom-in"
                          type="submit"
                          @click="submit"
                          :disabled="saving"
                        >
                          <i class="mdi mdi-content-save" />
                          {{ $t("Salvar") }}
                        </button>
                      </div>
                    </div>
                    <div v-if="item.anexos">
                      <anexos :anexos="item.anexos" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Grupo SCFV</h4>
                    </div>
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="item.id"
                      :familia="0"
                      :status="status_item"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <UsuariosVinculado :item="item" v-if="page == 'usuariosvinculado'" />

          <Atividade :item="item" v-if="page == 'atividade'" />

          <Encaminhamento :item="item" v-if="page == 'encaminhamento'" />
          <Logs :item="item" v-if="page == 'auditoria'" />

          <Comentario :item="item" v-if="page == 'comentario'" />

          <ParticipacoesAtividades
            :item="item"
            v-if="page == 'participacoes'"
          />
        </div>
      </div>
    </div>
    <status-historico
      :model="model"
      modulo="Scfv"
      titulo_modulo="SCFV"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      @submit="submit"
    />
  </div>
</template>
<script>
import { misMixins } from "./mixins.js";
import SearchTecnicoGrupo from "./SearchTecnicoGrupo.vue";
import HistoricoStatus from "./HistoricoStatus";
import Header from "./Header";
import Sidebar from "./includes/Sidebar";
import Atividade from "./includes/abas/Atividade";
import Encaminhamento from "./includes/abas/Encaminhamento";
import UsuariosVinculado from "./includes/abas/UsuariosVinculado";
import Comentario from "./includes/abas/Comentario";
import Logs from "./includes/abas/Logs";
import ParticipacoesAtividades from "./includes/abas/ParticipacoesAtividades.vue";

function normalizarTecnicos(valor) {
  if (valor === null || valor === undefined || valor === "") {
    return [];
  }

  if (Array.isArray(valor)) {
    return valor.slice();
  }

  if (typeof valor === "string") {
    try {
      const tecnicos = JSON.parse(valor);
      if (Array.isArray(tecnicos)) {
        return tecnicos;
      }
    } catch (error) {
      // Um formato inválido deve ser informado, sem apagar a seleção existente.
    }
  }

  throw new Error("A lista de técnicos participantes está em formato inválido.");
}

function mensagemErro(error, padrao) {
  const dados = error && error.response && error.response.data;
  if (dados && dados.errors && typeof dados.errors === "object") {
    const mensagens = Object.keys(dados.errors)
      .reduce((lista, campo) => lista.concat(dados.errors[campo]), [])
      .filter((mensagem) => typeof mensagem === "string");
    if (mensagens.length > 0) {
      return mensagens.join("\n");
    }
  }

  if (dados && typeof dados.message === "string") {
    return dados.message;
  }

  return error && error.message ? error.message : padrao;
}

export default {
  components: {
    HistoricoStatus,
    Header,
    Atividade,
    Encaminhamento,
    UsuariosVinculado,
    Sidebar,
    Comentario,
    Logs,
    ParticipacoesAtividades,
    SearchTecnicoGrupo,
  },
  name: "Edit",
  data() {
    return {
      page: "scfv",
      loading: true,
      saving: false,
      format_hora: "",
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      item: {
        id: null,
        tecnicos: [],
        lista_inscritos: [],
      },
      files: [],
      status: [],
      status_item: [],
      progressCompleted: 0,
      subtipoAtual: "",
      model: "ScfvGrupo",
      campoExtra: false,
      unidades: [],
      tecnicos: [],
      user_id: null,
      tecnico_id: null,
    };
  },
  mixins: [misMixins],
  mounted() {
    this.$root.$on("usuariosvinculado", () => {
      this.getItem();
    });
  },
  beforeDestroy() {
    this.$root.$off("usuariosvinculado");
  },
  methods: {
    calcularIdade(value) {
      var birthday = +new Date(value);
      return ~~((Date.now() - birthday) / 31557600000);
    },
    formaExecucao() {
      if (this.item.forma_execucao == 2) {
        this.campoExtra = true;
      } else {
        this.campoExtra = false;
      }
    },
    showPage(page) {
      this.page = page;
    },
    getItem() {
      this.loading = true;
      return axios
        .get(`api/dashboard/scfv/${this.$route.params.id}`)
        .then((response) => {
          this.tecnico_id = this.$store.state.user.tecnico.id;
          this.user_id = this.$store.state.user.id;
          const dados = response.data.data;
          const tecnicos = normalizarTecnicos(dados.tecnicos);
          this.statusAnterior = dados.status;
          const user = this.$store.state.user;
          const isCoordenadorDaUnidade =
            user.role_details &&
            user.role_details.name == "Coordenador" &&
            user.tecnico &&
            user.tecnico.unidade_id == dados.unidade_id;

          if (
            isCoordenadorDaUnidade ||
            dados.user_id == this.user_id ||
            dados.tecnico_id == this.tecnico_id ||
            dados.orientador_id == this.tecnico_id ||
            dados.facilitador_id == this.tecnico_id ||
            this.isTecnicoParticipante(tecnicos)
          ) {
            this.item = Object.assign({ lista_inscritos: [] }, dados, {
              id: dados.id || this.$route.params.id,
              tecnicos,
            });
            this.format_hora = dados.horario || "";
            this.formaExecucao();
          } else {
            swal.fire({
              title: "Ops!",
              html: "Apenas quem cadastrou, coordenador da unidade, técnico responsável, técnicos participantes, facilitador e orientador podem editar este grupo!",
              icon: "error",
            });
            this.$router.push("/dashboard/scfv");
          }
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            text: mensagemErro(error, "O item não foi carregado corretamente."),
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    isTecnicoParticipante(tecnicos) {
      let user_logado = this.$store.state.user.tecnico.id;

      let is_tecnico = false;
      if (Array.isArray(tecnicos)) {
        tecnicos.forEach((id) => {
          if (id == user_logado) {
            is_tecnico = true;
          }
        });
      }
      return is_tecnico;
    },
    submit() {
      if (this.saving || this.loading || !this.item.id) {
        return;
      }

      let formData;
      try {
        const tecnicos = normalizarTecnicos(this.item.tecnicos);
        if (this.format_hora && this.format_hora != "") {
          this.item.horario = this.format_hora;
        }
        formData = new FormData();

        if (this.files && this.files.length > 0) {
          for (const i of Object.keys(this.files)) {
            formData.append("files[]", this.files[i]);
          }
        }

        for (const key of Object.keys(this.item)) {
          if (key !== "tecnicos" && key !== "tecnicos_contexto") {
            formData.append(key, this.item[key]);
          }
        }
        formData.append("tecnicos", JSON.stringify(tecnicos));
      } catch (error) {
        swal.fire({
          title: "Ops!",
          text: mensagemErro(error, "Não foi possível preparar a atualização do grupo."),
          icon: "error",
        });
        return;
      }

      this.saving = true;
      const ladda = Ladda.create(this.$el.querySelector(".btn-submit"));
      ladda.start();

      return axios
        .post(`api/dashboard/update/scfv`, formData, {
          onUploadProgress: (event) => {
            this.progressCompleted = event.total
              ? Math.round((event.loaded * 100) / event.total)
              : 0;
          },
        })
        .then((response) => {
          this.files = [];
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          // A resposta do update contém a mensagem, não os dados do grupo.
          return this.getItem();
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            text: mensagemErro(error, "Não foi possível atualizar o grupo."),
            icon: "error",
          });
        })
        .finally(() => {
          ladda.stop();
          this.saving = false;
          this.progressCompleted = 0;
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
